import { getIcon, type IconName, iconNames } from './helpers/icons'
import { oneOfStringsAttributeSchema } from './helpers/yup'
import { html, LitElement } from 'lit'
import { property, customElement } from 'lit/decorators.js'

export const iconNameSchema = oneOfStringsAttributeSchema(...iconNames)

@customElement('zaptic-icon')
export class Icon extends LitElement {
    @property({
        attribute: 'icon-name' /* for backwards compatibility */,
        converter: (val) => iconNameSchema.validateSync(val),
    })
    iconName: IconName

    render() {
        return html`${getIcon(this.iconName)}`
    }

    protected createRenderRoot() {
        // this lets CSS leak inside
        return this
    }
}
